import { ReactNode } from "react";
import { strings } from "../../../strings/strings";
import { MtplQuotation } from "../../../model/quotation";

enum ProductType {
    MTPL = "MTPL",
    GREEN_CARD = "GREEN_CARD",
    TRAVEL = "TRAVEL"
}

type ProductLinkKey =
    | "Автоцивілка"
    | "Автоцивілка Все включено"
    | "Зелена картка"
    | "Туристичне страхування";

const productLinks: Record<ProductLinkKey, string> = {
    "Автоцивілка": "https://arx.com.ua/produkty/avtotsyvilka/avtotsyvilka-online",
    "Автоцивілка Все включено": "https://arx.com.ua/produkty/avtotsyvilka/avtotsyvilka-vse-vklyucheno",
    "Зелена картка": "https://arx.com.ua/produkty/greencard",
    "Туристичне страхування": "https://arx.com.ua/produkty/turystychne-strakhuvannya/turystychne-strakhuvannya"
};

const INFORMATION_LINK = 'https://arx.com.ua/uploads/530/Informatsiia_pro_ARKS_vidpovidno_do_s87_pro_strakhuvannia.pdf';

function createAgreementUserInformedString(productLinkKey: ProductLinkKey): ReactNode {
    const productLink = productLinks[productLinkKey];

    return (
        <>
            {strings.agreementUserInformedPart1}{" "}
            <a href={productLink} target="_blank" rel="noopener noreferrer">
                {productLinkKey}
            </a>{" "}
            {strings.agreementUserInformedPart2}{" "}
            <a href={INFORMATION_LINK} target="_blank" rel="noopener noreferrer">
                {INFORMATION_LINK}
            </a>{" "}
            {strings.agreementUserInformedPart3}
        </>
    );
}

function getAgreeAboutProductLabel(
    productType: ProductType,
    quotation?: MtplQuotation
): ReactNode {
    if (productType === ProductType.MTPL && !quotation) {
        return createAgreementUserInformedString("Автоцивілка");
    }

    switch (productType) {
        case ProductType.MTPL:
            if (quotation) {
                const { cascoAdditionalCoverage } = quotation;
                if (cascoAdditionalCoverage.covered) {
                    return createAgreementUserInformedString("Автоцивілка Все включено");
                } else {
                    return createAgreementUserInformedString("Автоцивілка");
                }
            }
            return null;

        case ProductType.GREEN_CARD:
            return createAgreementUserInformedString("Зелена картка");

        case ProductType.TRAVEL:
            return createAgreementUserInformedString("Туристичне страхування");
    }
}

export {
    createAgreementUserInformedString,
    getAgreeAboutProductLabel,
    ProductType
};
